import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  NavigationEventLabels,
  NavigationEventMap,
  type TrackNavigationEvent,
} from './events';

/**
 * Custom hook to handle sidebar and navigation tracking events
 */
export function useTrackNavigationAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackNavigationEvent, extra?: Record<string, unknown>) => {
      const eventLabel = NavigationEventLabels[event];
      const eventInfo = NavigationEventMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
